type ID = `${string}_${number}`;

export default function getOrderedPlaceId(
  place: { canonicalName: string },
  index: number,
): ID {
  return `${place.canonicalName}_${index}`;
}
